import { useEffect } from 'react'
import { useAuthStore, supabase } from '@/stores/auth-store'

export function AuthProvider({ children }: { readonly children: React.ReactNode }): React.ReactElement {
  const setSession = useAuthStore((s) => s.setSession)
  const setInitialized = useAuthStore((s) => s.setInitialized)

  useEffect(() => {
    // Get cached session, then verify the user still exists on the server.
    // After a DB reset the local JWT is still valid but the user row is gone —
    // getUser() catches this and we clear the stale session automatically.
    supabase.auth.getSession().then(async ({ data: { session } }) => {
      if (session) {
        const { error } = await supabase.auth.getUser()
        if (error) {
          await supabase.auth.signOut()
          setSession(null)
          setInitialized()
          return
        }
      }
      setSession(session)
      setInitialized()
    })

    // Listen for auth state changes
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session)
    })

    return () => {
      subscription.unsubscribe()
    }
  }, [setSession, setInitialized])

  return <>{children}</>
}
